import React from 'react'
import styled from 'styled-components'
import Button from '../buttons/buttons.component'
import PropTypes from 'prop-types'

const StyledBackdrop = styled.div`
	align-items: center;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	height: 100vh;
	justify-content: center;
	left: 0;
	position: fixed;
	top: 0;
	width: 100vw;
	z-index: 5;

	@media screen and (min-width: 480px) {
		justify-content: center;
	}
`

const StyledModal = styled.div`
	background: #fff;
	border-radius: 5px;
	box-sizing: border-box;
	max-height: calc(100vh - 100px);
	padding: 25px;
	position: relative;
	width: calc(100% - 30px);

	@media screen and (min-width: 480px) {
		max-width: 700px;
		min-width: 300px;
		width: auto;
	}

	@media screen and (max-width: 700px) {
		width: 80%;
	}

	.title {
		margin-bottom: 3rem;
		text-align: left;
		user-select: none;
		line-height: 1em;
	}

	.modal-content {
		font-size: 1.8rem;
		max-height: calc(100vh - 250px);
		margin-bottom: 3rem;
	}
`

const StyledButtonWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;

	& > * {
		margin-top: 1rem;
		&:first-child {
			margin-top: 0;
		}
	}

	@media screen and (min-width: 480px) {
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;

		& > * {
			margin-top: 0;
			margin-right: 1.5rem;
			&:last-child {
				margin-right: 0;
			}
		}
	}
`

class ModalConfirmation extends React.Component {
	constructor(props) {
		super(props)
		this.state = { fade: false }
	}

	render() {
		const {
			title,
			isOpen,
			reverse,
			children,
			onResult,
			OnlyNoButton,
			buttonNoText,
			buttonYesText,
		} = this.props

		const buttons = [
			<Button
				key="btnyes"
				link={reverse}
				primary={!reverse}
				onClick={(e) => {
					e.preventDefault()
					onResult(true)
				}}>
				{buttonYesText || 'Sim'}
			</Button>,
			<Button
				key="btnno"
				link={!reverse}
				primary={reverse}
				onClick={(e) => {
					e.preventDefault()
					onResult(false)
				}}>
				{buttonNoText || 'Não'}
			</Button>,
		]

		const noButton = [
			<Button
				key="btnno"
				link={!reverse}
				primary={reverse}
				onClick={(e) => {
					e.preventDefault()
					onResult(false)
				}}>
				{buttonNoText || 'Não'}
			</Button>,
		]

		if (reverse) {
			buttons.reverse()
		}

		return isOpen ? (
			<StyledBackdrop
				className={`animated ${this.state.fade && 'fadeOut'}`}
				onClick={() => onResult(false)}>
				<StyledModal
					className="animated slideInDown"
					onClick={(e) => e.stopPropagation()}>
					{title ? <div className="title">{title}</div> : null}
					<div className="modal-content">{children}</div>
					<StyledButtonWrapper>
						{OnlyNoButton ? noButton : buttons}
					</StyledButtonWrapper>
				</StyledModal>
			</StyledBackdrop>
		) : null
	}
}

ModalConfirmation.propTypes = {
	isOpen: PropTypes.bool,
	onResult: PropTypes.func.isRequired,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export default ModalConfirmation
